<template>
    <div>
        <NovaUnimed style="height: 100%;"/>
    </div>
</template>

<script>
import NovaUnimed from '../components/NovaUnimed/NovaUnimed'
export default {
  components: {
    NovaUnimed
  }
}
</script>

<style>

</style>
